const ALPHA_CONFIG = {
    "REACT_APP_USER_POOL_ID":"us-west-2_BeMPmp3E3",
    "REACT_APP_USER_POOL_WEB_CLIENT_ID":"4rij55mle85hp62om0272opa1j",
    "REACT_APP_COGNITO_DOMAIN":"cog-approvermatrix-na-alpha.auth.us-west-2.amazoncognito.com",
    "REACT_APP_REDIRECT_URL":"https://alpha.checkpoint.lab126.amazon.dev",
    "REACT_APP_API_ENDPOINT":"https://9aukmp79wi.execute-api.us-west-2.amazonaws.com/Alpha"}

export default ALPHA_CONFIG